import type { CluePublic } from '@cloudfruit-hunts/shared';

interface AudioClueProps {
  clue: CluePublic;
}

export function AudioClue({ clue }: AudioClueProps) {
  const audioUrl = clue.assetUrls[0];

  return (
    <div className="py-4">
      <p className="text-lg text-text-dark leading-relaxed mb-4">
        {clue.contentText}
      </p>

      {audioUrl && (
        <div className="bg-cream p-6 rounded-lg">
          <audio controls className="w-full mb-4">
            <source src={audioUrl} type="audio/wav" />
            Your browser does not support audio playback.
          </audio>

          <a
            href={audioUrl}
            download
            target="_blank"
            rel="noopener noreferrer"
            className="btn-secondary inline-flex items-center gap-2"
          >
            <DownloadIcon />
            Download Audio File
          </a>

          <p className="mt-4 text-sm text-text-light italic">
            Listening won't be enough. Download it and find another way to look at the sound.
          </p>
        </div>
      )}
    </div>
  );
}

function DownloadIcon() {
  return (
    <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={2}
        d="M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-4l-4 4m0 0l-4-4m4 4V4"
      />
    </svg>
  );
}
